import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Field, change } from 'redux-form';
import { FORM_NAME } from './index';
import FormField from '../form-field';
import FacebookButton from '../../containers/facebook-button.container';
import { formatMessage } from '../../lib/intl';
import '../../css/embedded-signup.css';

class SignupAsInvitee extends Component {
  constructor(props) {
    super(props);
    this.state = { dontCreate: false };
    this.onDontCreateChange = this.onDontCreateChange.bind(this);
    this.formatMessage = formatMessage(this.props.intl);
  }

  componentDidUpdate() {
    change(FORM_NAME, '_validateHack', new Date());
  }

  onDontCreateChange({ target: { checked: dontCreate } }) {
    this.setState({ dontCreate });
  }

  onSendGuestLink = () => {
    this.props.onSendGuestLink();
  }

  showingExistent() {
    return this.props.method === 'email' || this.props.method === 'facebook';
  }

  showingGuestLink() {
    return this.props.method === 'guest';
  }

  showingFacebookButton() {
    return this.props.method === 'facebook';
  }

  disablePassword() { return this.state.dontCreate || this.showingExistent(); }

  renderEmailSubtext() {
    if (this.showingFacebookButton()) {
      return (
        <span className="coral-error">
          <FormattedMessage
            id="commitForm.signup.invitee.emailField.subtext.connectedWithFacebook"
            defaultMessage="Aha! You already connected with Facebook"
          />
        </span>
      );
    }

    if (this.showingExistent()) {
      return (
        <span className="coral-error">
          <FormattedMessage
            id="commitForm.signup.invitee.emailField.subtext.connectedWithEmail"
            defaultMessage="Aha! You already have an account"
          />
          <button
            type="button"
            className="btn-link log-in-link"
            onClick={this.props.onLogin}
          >
            <FormattedMessage
              id="commitForm.signup.invitee.emailField.subtext.logInButton"
              defaultMessage="Log in"
            />
          </button>
        </span>
      );
    }

    if (this.showingGuestLink()) {
      return (
        <span>
          <FormattedMessage
            id="commitForm.signup.invitee.emailField.subtext.guestAccount"
            defaultMessage="You have a guest account"
          />
        </span>
      );
    }

    return (
      <span>
        <FormattedMessage
          id="commitForm.signup.invitee.emailField.subtext.useFacebook"
          defaultMessage="Or use"
        />
        {' '}
        <FacebookButton onConnect={this.props.onFacebookConnect} asLink>
          <FormattedMessage
            id="commitForm.signup.invitee.emailField.subtext.facebookConnect"
            defaultMessage="Facebook Connect"
          />
        </FacebookButton>
      </span>
    );
  }

  renderPasswordSubText() {
    if (this.showingExistent()) return null;

    return (
      <Field
        className="create-guest-account"
        name="createGuestAccount"
        type="checkbox"
        component={FormField}
        label={
          <FormattedMessage
            id="comitForm.signup.invitee.passwordField.subtext.label"
            defaultMessage="Don't create an account, just contribute."
          />
        }
        onChange={this.onDontCreateChange}
      />
    );
  }

  renderFacebookButton() {
    return (
      <div className="col-6">
        <div className="form-group pt-2">
          <p className="pt-4">
            <FacebookButton onConnect={this.props.onFacebookConnect}>
              <FormattedMessage
                id="commitForm.signup.invitee.facebookButton.logInWithFacebook"
                defaultMessage="Log in with Facebook"
              />
            </FacebookButton>
          </p>
        </div>
      </div>
    );
  }

  renderGuestLink() {
    return (
      <div className="col-6">
        <div className="form-group">
          <p className="pt-4">
            <sub className="small-print coral-error">
              <FormattedMessage
                id="commitForm.signup.invitee.guestLink.notice"
                defaultMessage="You already joined as a guest.
                  To update your contribution, you must verify your email."
              />
              <button
                type="button"
                className="btn-link send-guest-link"
                onClick={this.onSendGuestLink}
              >
                <FormattedMessage
                  id="commitForm.signup.invitee.guestLink.sendLink"
                  defaultMessage="Send me a link to authenticate."
                />
              </button>
            </sub>
          </p>
        </div>
      </div>
    );
  }

  renderPasswordField() {
    const i18n = defineMessages({
      passwordLabel: {
        id: 'commitForm.signup.invitee.passwordField.label',
        defaultMessage: 'Password',
      },
      passwordPlaceholder: {
        id: 'commitForm.signup.invitee.passwordField.placeholder',
        defaultMessage: 'Enter a password',
      },
    });
    return (
      <div className="col-6">
        <Field
          name="password"
          type="password"
          component={FormField}
          label={this.formatMessage(i18n.passwordLabel)}
          placeholder={this.formatMessage(i18n.passwordPlaceholder)}
          subtext={this.renderPasswordSubText()}
          disabled={this.disablePassword()}
          keepSubtext
          required
        />
      </div>
    );
  }

  renderPasswordOrGuest() {
    if (this.showingGuestLink()) return this.renderGuestLink();
    if (this.showingFacebookButton()) return this.renderFacebookButton();

    return this.renderPasswordField();
  }

  render() {
    const i18n = defineMessages({
      emailLabel: {
        id: 'commitForm.signup.invitee.emailField.label',
        defaultMessage: 'Email',
      },
      emailPlaceholder: {
        id: 'commitForm.signup.invitee.emailField.placeholder',
        defaultMessage: 'Enter an email',
      },
    });
    return (
      <div className="embedded-registration">
        <div className="row no-gutters signup-form">
          <div className="col-6 email-input-wrapper">
            <Field
              name="email"
              type="email"
              placeholder={this.formatMessage(i18n.emailPlaceholder)}
              component={FormField}
              label={this.formatMessage(i18n.emailLabel)}
              onChange={this.props.onEmailChange}
              subtext={this.renderEmailSubtext()}
              keepSubtext
              required
            />
          </div>
          {this.renderPasswordOrGuest()}
        </div>
      </div>
    );
  }
}

SignupAsInvitee.defaultProps = {
  onDontCreateAccount: () => {},
};

export default injectIntl(SignupAsInvitee);



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/signup.invitee.js